/*
 * @Author: chenx
 * @CreatedDate: Do not edit
 * @LastEditTime: 2021-04-01 16:41:52
 * @Description: file content
 */
// event-bus.js
import Vue from 'vue'
const EventBus = new Vue()
export default EventBus
